import Vue from 'vue'
import Vuex from 'vuex'
import { reqLogin2, getUserInfo } from '@/apis/login.js'
import { setCookie } from '@/tools/'
import $ajax from 'axios'
import { showLoad,hideLoad } from '@/tools/loading.js' // 引入封装的loading方法
import { getVendorOrgCodeInfo, newCetVendorOrgCodeInfo } from '@/apis/cms.js'
import { isGY } from '@/utils/api'
import jxStorePick from './storePick.js'
import { getCate } from "@/apis/goods.js";

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: debug,
  state: {
    pickVendorIDS: [],
    user: '',
    userRole: {},
    Token: '',
    serverInfo: '',
    isRouterAlive: true, // 用来点击相同router-link刷新页面
    maxStoresLength: 0,
    storesPick: [],
    skusPick: '',
    vendorOrgCode: null,
    newPlateForm: null,
    systemInfo: {},
    yunyingMap: {},
    memberMap: {},
    highRoot: {},
    yunyingLeader: {},
    rootGoodManager: {},
    AllplateArr: [],
    jdVendorArr: [],
    ebaiVendorArr: [],
    MtVendorArr: [],
    DyVendorArr: [],
    TaoVendorArr: [],
    jdStoreVendorArr: [],
    accoutShow: false,//结算信息是否显示
    actCheckedArr: [],
    marketsArr: [],
    jdStore: [],
    mtStore: [],
    ebStore: [],
    jDCategoryData: [],
    jGCategoryData: [],
    mTCategoryData: [],
    dYCategoryData: [],
    // taoCategoryData: [],
    eBCategoryData: [],
  },
  mutations: {
    SET_jDCategory: (state, data) => {
      state.jDCategoryData = data
    },
    SET_jGCategory: (state, data) => {
      state.jGCategoryData = data
    },
    SET_mTCategory: (state, data) => {
      state.mTCategoryData = data
    },
    SET_dYCategory: (state, data) => {
      state.dYCategoryData = data
    },
    SET_eBCategory: (state, data) => {
      state.eBCategoryData = data
    },
    SET_VENDORIDS: (state, data) => {
      state.pickVendorIDS = data
    },
    SET_ACCOUNT: (state, data) => {
      state.accoutShow = data
    },
    SET_ALLPLATEARR: (state, arr) => {
      state.AllplateArr = arr
    },
    SET_JDVENDOR: (state, arr) => {
      state.jdVendorArr = arr
    },
    SET_EBVENDOR: (state, arr) => {
      state.ebaiVendorArr = arr
    },
    SET_MTVENDOR: (state, arr) => {
      state.MtVendorArr = arr
    },
    SET_DYVENDOR: (state, arr) => {
      state.DyVendorArr = arr
    },
    SET_TAOVENDOR: (state, arr) => {
      state.TaoVendorArr = arr
    },
    SET_JDSTOREVENDOR: (state, arr) => {
      state.jdStoreVendorArr = arr
    },
    DEL_SKUS: (state) => {
      state.skusPick = ''
    },
    SET_STORES: (state, stores) => {
      state.storesPick = [...stores]
    },
    SET_ACTSTORES: (state, stores) => {
      state.actCheckedArr = [...stores]
    },
    DEL_STORES: (state) => {
      state.storesPick = []
    },
    SET_TOKEN: (state, token) => {
      state.Token = token
    },
    SET_USER: (state, data) => {
      state.user = data
    },
    DELETE_USERINFO: state => {
      state.user = ''
    },
    DELETE_TOKEN: state => {
      state.Token = ''
      setCookie('Token', '', -1)
    },
    // 点击相同router-link，刷新组件
    CHANGE_ROUTER: (state, boo) => {
      state.isRouterAlive = boo
    },
    // 设置CMS信息
    SET_SERVERINFO: (state, data) => {
      state.serverInfo = data
    },
    // 设置服务器时间信息
    SET_SYSINFO: (state, json) => {
      // let {buildTime, startupTime} = json
      state.systemInfo = json
    },
    // 设置最大门店数量
    SET_STORESLENGTH: (state, num) => {
      state.maxStoresLength = +num
    },
    set_role: (state, json) => {
      state.userRole = json
    },
    save_vendorOrgCode: (state, json) => {
      state.vendorOrgCode = json
    },
    save_vnewPlateForm: (state, json) => {
      state.newPlateForm = json
    },
    setRootMap: (state, json) => {
      state.yunyingMap = json.yunyingMap
      state.memberMap = json.memberMap
      state.highRoot = json.highRoot
      state.yunyingLeader = json.yunyingLeader
      state.rootGoodManager = json.rootGoodManager
    },
    setMarket: (state, arr) => {
      state.marketsArr = arr
    },
    setJD: (state, arr) => {
      state.jdStore = arr
    },
    setMT: (state, arr) => {
      state.mtStore = arr
    },
    setEB: (state, arr) => {
      state.ebStore = arr
    }
  },
  actions: {
    async getAllPlate({ commit }) {
      const res = await $ajax.get('v2/cms/QueryConfigs?key=FZR')
      const data = JSON.parse(res.data.data)
      const info = JSON.parse(data[0].value)
      commit('setMarket', info.jx)
      commit('setJD', info.jd)
      commit('setMT', info.mt)
      commit('setEB', info.eb)
    },
    // 钉钉扫码登录
    LoginByDD({ commit }, res) {
      // 存储token
      setCookie('Token', res.token, 7)
      localStorage.setItem('userID', res.userID)
      localStorage.setItem('mobile', res.mobile)
      // state 存储token
      commit('SET_TOKEN', res.token)
    },
    // 账号密码登录
    LoginByUsername({ commit }, loginForm) {
      // const user = loginForm.user.trim()
      // const pass = loginForm.pass.trim()
      return new Promise((resolve, reject) => {
        // 请求登录接口,获取token
        reqLogin2(loginForm, data => {
          if (data.code === '0') {
            // 登录成功
            const loginData = JSON.parse(data.data)
            // 存储token
            setCookie('Token', loginData.token, 7)
            localStorage.setItem('userID', loginData.userID)
            localStorage.setItem('mobile', loginData.mobile)
            // state 存储token
            commit('SET_TOKEN', loginData.token)
            // 成功处理
            resolve(data)
          } else {
            reject(data.desc)
          }
        })
      })
    },
    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        // 请求
        getUserInfo(state.Token, async data => {
          if (data.code === '0') {
            // 获取成功
            const userData = JSON.parse(data.data)
            commit('SET_USER', userData)

            try {
              // 获取服务信息
              let [res1, res3, res4] = await Promise.all(
                [
                  $ajax('v2/cms/GetServiceInfo'),
                  getVendorOrgCodeInfo(),
                  newCetVendorOrgCodeInfo()
                ]
              )
              let { code: code1, data: CMS, desc: desc1 } = res1.data
              let cms
              if (code1 === '0') {
                commit('SET_SERVERINFO', JSON.parse(CMS).metaData)
                cms = JSON.parse(CMS).metaData
                commit('SET_SYSINFO', {
                  info: JSON.parse(CMS)
                })
              } else {
                throw desc1
              }

              if (res4) {
                commit('SET_ALLPLATEARR', res4) //全部的平台
                let jdArr = res4.filter(item => item.code === 0)
                let ebArr = res4.filter(item => item.code === 3)
                let MTArr = res4.filter(item => item.code === 1)
                let DYArr = res4.filter(item => item.code === 14)
                let TaoArr = res4.filter(item => item.code === 16)
                let jdStoreArr = res4.filter(item => item.code === 5)
                commit('SET_ALLPLATEARR', res4) //全部的平台
                commit('SET_JDVENDOR', jdArr) //京东
                commit('SET_EBVENDOR', ebArr) //饿百
                commit('SET_MTVENDOR', MTArr) //美团
                commit('SET_DYVENDOR', DYArr) //抖店
                commit('SET_TAOVENDOR', TaoArr) //淘鲜达
                commit('SET_JDSTOREVENDOR', jdStoreArr) //京东商城
                commit('save_vendorOrgCode', res3)
              }
              let arr = []
              let code = res3
              for (let i in code) {
                if (code[i]) {
                  for (let item of code[i]) {
                    if (item === '362665') {
                      arr.push({
                        key: item,
                        code: i,
                        name: cms.vendorName[i] + '京东超市'
                      })
                    } else if (item === '359459') {
                      arr.push({
                        key: item,
                        code: i,
                        name: cms.vendorName[i] + '自配送'
                      })
                    } else if (item === "349454") {
                      arr.push({
                        key: item,
                        code: i,
                        name: cms.vendorName[i] + '小城市'
                      })
                    } else {
                      arr.push({
                        key: item,
                        code: i,
                        name: cms.vendorName[i]
                      })

                    }
                  }
                }
              }
              commit('save_vnewPlateForm', arr)
            } catch (e) {
              reject(e)
            } finally {
              hideLoad()
            }
            resolve(data)
          } else {
            // 获取失败
            reject(data.desc)
          }
        })
      })
    },
    // 登出
    LoginOut({ commit }) {
      commit('DELETE_USERINFO') // 删除用户信息
      commit('DELETE_TOKEN') // 删除token
    },
    // 点击相同router-link，刷新组件
    RefreshPage({ commit }, boo) {
      commit('CHANGE_ROUTER', boo)
    },
    // 获取分类信息
    async getCate({commit,state},params){
      let valueNew = ''
      switch(params.vendorID){
        case 0:
          valueNew = {
            name:'京东',
            commitName:'SET_jDCategory'
          }
          break
        case 1:
            valueNew = {
              name:'美团',
              commitName:'SET_mTCategory'
            }
            break
        case 3:
            valueNew = {
              name:'饿百',
              commitName:'SET_eBCategory'
            }
            break
        case 5:
          valueNew = {
            name:'京狗',
            commitName:'SET_jGCategory'
          }
          break
        // case 9:
        //   valueNew = {
        //     name:'京西',
        //     commitName:'SET_eBCategory'
        //   }
        //   break
        case 14:
          valueNew = {
            name:'抖店',
            commitName:'SET_dYCategory'
          }
          break
        default:
          valueNew = '未知'
      }
      if(valueNew === '未知') return
      showLoad(`正在获取${valueNew.name}分类`)
      const res = await getCate(params)
      let level1 = res.filter(item => item.level === 1)
      let level2 = res.filter(item => item.level === 2)
      let level3 = res.filter(item => item.level === 3)
      let level4 = res.filter(item => item.level === 4)
      let CatNew = combinationCategory(level1,level2,level3,level4)
      let arr = [level1,level2,level3,level4,CatNew].filter(item => item.length>0)
      // console.log(CatNew,'打印分类信息的结果','state',arr,'arrnew',valueNew)
      commit(valueNew.commitName,arr)
      hideLoad()
    },
  },
  getters: {
    accoutShow: state => state.accoutShow,
    isNewPriceDisplay: state => {
      return !isGY
    },
    userInfo: state => state.user,
    serverInfo: state => state.serverInfo,
    CMS: state => state.serverInfo,
    cms: state => state.serverInfo,
    systemInfo: state => state.systemInfo,
    maxStoresLength: state => state.maxStoresLength,
    stores: state => state.storesPick,
    actCheckedArr: state => state.actCheckedArr,
    skus: state => state.skusPick,
    userRole: state => state.userRole,
    vendorOrgCode: state => state.vendorOrgCode,
    newPlateForm: state => state.newPlateForm,
    yunyingMap: state => state.yunyingMap,
    memberMap: state => state.memberMap,
    highRoot: state => state.highRoot,
    yunyingLeader: state => state.yunyingLeader,
    rootGoodManager: state => state.rootGoodManager,
    AllplateArr: state => state.AllplateArr,
    jdVendorArr: state => state.jdVendorArr,
    ebaiVendorArr: state => state.ebaiVendorArr,
    MtVendorArr: state => state.MtVendorArr,
    DyVendorArr: state => state.DyVendorArr,
    TaoVendorArr: state => state.TaoVendorArr,
    jdStoreVendorArr: state => state.jdStoreVendorArr,
    marketsArr: state => state.marketsArr,
    jdStore: state => state.jdStore,
    mtStore: state => state.mtStore,
    ebStore: state => state.ebStore,
    jDCategoryData: state => state.jDCategoryData,
    jGCategoryData: state => state.jGCategoryData,
    mTCategoryData: state => state.mTCategoryData,
    dYCategoryData: state => state.dYCategoryData,
    // taoCategoryData: state => state.taoCategoryData,
    eBCategoryData: state => state.eBCategoryData
    // flatVendorOrgCode: state => {
    //   let vendorOrgCode = state.vendorOrgCode
    //   // {"0":["320406", ["23434223"]],"1":["589"],"3":["34665"]}
    //   let arr
    // }
  },
  modules: {
    jxStorePick
  }
})


function combinationCategory(cat1,cat2,cat3,cat4) {
  if(cat4 && cat4.length>0){
    // 四级挂载到三级
    cat3.forEach((le3) => {
      let level4 = cat4.filter(
        (le4) => Number(le4.parentID) === Number(le3.vendorCategoryID)
      );
      if(level4.length>0){
        le3.children = level4
      }
    })
  }

  // 三级挂载到二级
  cat2.forEach((le2) => {
    let level3 = cat3.filter(
      (le3) => Number(le3.parentID) === Number(le2.vendorCategoryID)
    );
    if(level3.length>0){
      le2.children = level3;
    }
  });

  // 二级挂载到一级
  cat1.forEach((le1) => {
    let level2 = cat2.filter(
      (le2) => Number(le2.parentID) === Number(le1.vendorCategoryID)
    );
    if(level2.length>0){
      le1.children = level2;
    }
  });

  return cat1;
}


// WEBPACK FOOTER //
// ./src/store/index.js